<template>
  <v-app-bar dark absolute color="primary" elevate-on-scroll>
    <v-toolbar-title>{{ getPhrase(title) }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-app-bar-nav-icon @click="drawer = true" class="d-flex d-md-none"
      ><v-icon>mdi-dots-vertical</v-icon></v-app-bar-nav-icon
    >
    <ent-nav-button-row
      :config="args"
      :buttonclick.sync="navbuttons"
      class="d-none d-md-flex"
    ></ent-nav-button-row>
    <v-navigation-drawer
      v-model="drawer"
      app
      absolute
      right
      width="30%"
      v-if="drawer"
    >
      <v-list nav dense v-if="drawer">
        <template v-for="button in button_list">
          <v-list-item
            @click="processButtonClick(button.name)"
            v-if="enableDrawerButton(button.disable)"
            :key="button"
            >{{ getPhrase(button) }}</v-list-item
          >
        </template>
      </v-list>
    </v-navigation-drawer>
  </v-app-bar>
</template>
<script setup>
  import EntNavButtonRow from "@/../../library/view/EntNavButtonRow.vue";
  import phraseProc from "@/../../library/helper/phrase.js";
  import check from "@/../../library/helper/propertyCheck.js";
  import useVuexPathify from "@/../../library/compFunctions/useVuexPathify.js";
  import { ref, watch, getCurrentInstance, onMounted } from "vue";

  // Define the properties
  const props = defineProps({
    args: { type: Object, required: true },
    title: { type: String, required: false },
  });

  // Define the emits for this block
  const emit = defineEmits(["update:buttonclick"]);

  // Get the VM to access the store
  const vm = getCurrentInstance();
  const { get } = useVuexPathify(vm.proxy);
  const userlang = get("misc/language").value;
  const phrases = get("misc/phraseMap").value;

  // Define the button list
  const button_list = ref([]);

  // Define the state of the drawer
  let drawer = ref(false);
  const loading = true;

  // Figure out if the drawer button needs to be enabled
  const enableDrawerButton = (button) => {
    if (check.isUndefined(button)) return true;
    if (button) return false;
    return true;
  };

  // Handle clicking a button from the
  let navbuttons = ref(null);
  watch(navbuttons, () => {
    processButtonClick(navbuttons.value.click);
  });

  onMounted(() => {
    button_list.value = props.args.buttonList;
  });
  // Handle the event of clicking a button
  const processButtonClick = (button) => {
    emit("update:buttonclick", { click: button });
    drawer.value = false;
  };

  // Define the translation method
  const getPhrase = (button) => {
    return phraseProc.mapPhrase(button, phrases, userlang).toUpperCase();
  };
</script>
